import { render, staticRenderFns } from "./DiscountsBundles.vue?vue&type=template&id=07b7178f"
import script from "./DiscountsBundles.vue?vue&type=script&lang=js"
export * from "./DiscountsBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports